import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SunMinFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.95 35.94c7.494 0 13.57-6.076 13.57-13.57 0-7.494-6.076-13.57-13.57-13.57-7.494 0-13.569 6.076-13.569 13.57 0 7.494 6.075 13.57 13.57 13.57Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.95.42c.599 0 1.098.499 1.098 1.097v2.694c0 .599-.5 1.098-1.098 1.098a1.107 1.107 0 0 1-1.097-1.098V1.517C20.853.92 21.35.42 21.95.42ZM6.385 6.805c.5-.399 1.098-.399 1.597 0l1.896 1.896c.399.4.399 1.098 0 1.497-.4.399-1.098.399-1.497 0L6.385 8.402c-.399-.5-.399-1.098 0-1.597ZM0 22.37c0-.599.499-1.098 1.098-1.098H3.79c.599 0 1.098.5 1.098 1.098 0 .599-.499 1.098-1.098 1.098H1.098A1.107 1.107 0 0 1 0 22.37ZM9.778 34.542c.399.4.399 1.098 0 1.497l-1.796 1.896c-.4.399-1.098.399-1.497 0-.499-.5-.499-1.098-.1-1.597l1.896-1.895c.4-.4 1.098-.4 1.497.1ZM21.95 39.531c.599 0 1.098.499 1.098 1.098v2.693c0 .6-.5 1.098-1.098 1.098a1.107 1.107 0 0 1-1.097-1.098v-2.694c0-.598.498-1.097 1.097-1.097ZM34.123 34.542c.399-.399 1.097-.399 1.496 0l1.896 1.896c.399.4.399 1.098 0 1.497-.4.399-1.098.399-1.497 0l-1.895-1.896a.935.935 0 0 1 0-1.497ZM39.111 22.37c0-.599.499-1.098 1.098-1.098h2.694c.598 0 1.097.5 1.097 1.098 0 .599-.499 1.098-1.097 1.098h-2.694a1.107 1.107 0 0 1-1.098-1.098ZM37.515 6.805c.399.4.399 1.098 0 1.497l-1.896 1.896c-.399.399-1.097.399-1.496 0-.4-.4-.4-1.098 0-1.497l1.795-1.896c.5-.399 1.098-.399 1.597 0Z"
  })));
});
SunMinFill.displayName = 'SunMinFill';
SunMinFill.defaultProps = {
  'aria-label': 'SunMinFill'
};
export default SunMinFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SunMinFill.js
// module id = 3928
// module chunks = 11